import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { ThreeDots } from "react-loader-spinner";

// import { updateNotificationSounds } from "redux/chats/chats.actions";
import {
  NewMsgInConversationSounds,
  NewMsgSounds,
  NewVisitorSounds,
} from "assets/sounds/sounds";
import SelectBox from "../../../SelectBox";
import Switch from "../../../Switch";
import "./styles.scss";
import useTranslation from "hooks/useTranslation";
import TypicalHeader from "../Profile/components/Header/TypicalHeader";
import { Alarms } from "assets/icons";
import { checkNotificationPermission } from "utils/browserNotifs";
import { handleNotificationPermission } from "../../../../firebase";
import { setShowPopupNotifDisplay } from "redux/general-data/general-data.actions";

const getNotifications = ({ generalData }) => generalData.notifications;

const Notifications = ({ formData, setFormData }) => {
  const notifications = useSelector(getNotifications);
  const [isBrowserNotifActive, setIsBrowserNotifActive] = useState(false);
  const [isLoadingNotifActive, setIsLoadingNotifActive] = useState(false);
  const dispatch = useDispatch();
  const { getTranslation, getAppLocale } = useTranslation("COMMON");
  const locale = getAppLocale();
  const { t } = getTranslation();

  const showActiveBrowserNotif = !isBrowserNotifActive;

  const handleSelectSound = (e) => {
    var audio = new Audio(e.target.value);
    audio.play();

    setFormData((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  // const handleSendNotificatios = () => {
  //   dispatch(updateNotificationSounds(formData));
  // };

  const notifInputs = [
    {
      title: t("PROFILE").ALARMS.NEW_MSG_SOUND,
      Options: NewMsgSounds,
      key: "NewMsgSound",
    },
    {
      title: t("PROFILE").ALARMS.NEW_VISTOR_SOUND,
      Options: NewVisitorSounds,
      key: "NewVisitorSound",
    },
    {
      title: t("PROFILE").ALARMS.NEW_MSG_IN_CONV_SOUND,
      Options: NewMsgInConversationSounds,
      key: "NewMsgInConversationSound",
    },
  ];

  const handleClickBrowserNotifActive = async () => {
    if (isLoadingNotifActive) return;

    const result = await handleNotificationPermission(
      true,
      locale,
      setIsLoadingNotifActive
    );

    if (result === "success") {
      dispatch(setShowPopupNotifDisplay(true));
    }
  };

  const handleChangeAllNotifsEnable = () =>
    setFormData((prev) => {
      return {
        ...prev,
        enabled: !prev.enabled,
      };
    });

  const renderThreeDotsLoader = (
    <ThreeDots
      height="20"
      width="30"
      radius="9"
      color="#fff"
      ariaLabel="three-dots-loading"
      wrapperStyle={{ justifyContent: "center" }}
      visible={true}
    />
  );

  useEffect(() => {
    setFormData({
      enabled: notifications.enabled || false,
      NewMsgInConversationSound: notifications.NewMsgInConversationSound,
      NewMsgSound: notifications.NewMsgSound,
      NewVisitorSound: notifications.NewVisitorSound,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifications]);

  useEffect(() => {
    checkNotificationPermission(setIsBrowserNotifActive);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    formData && (
      <div>
        <TypicalHeader
          headerText={t("PROFILE").ALARMS.TITLE}
          iconAlt={"Alarms"}
          iconSrc={Alarms}
        />
        <div className="alarms-settings-container">
          <div className="alarms-status-container">
            <p>{t("PROFILE").ALARMS.ALARM_ACTIVATION}</p>

            <div className="flex flex-ai-c">
              <Switch
                onChange={handleChangeAllNotifsEnable}
                checked={formData.enabled}
              />
            </div>
          </div>

          {notifInputs.map((item, index) => (
            <div key={index} className="alarm-item">
              <p className="alarm-item-name">{item.title}</p>

              <div className="flex flex-ai-c alarm-item-select-container">
                <SelectBox
                  onChange={handleSelectSound}
                  options={item.Options}
                  name={item.key}
                  value={formData[item.key]}
                />
              </div>
            </div>
          ))}

          {showActiveBrowserNotif && (
            <div>
              <button
                onClick={handleClickBrowserNotifActive}
                className="settings_btn notif_active_btn"
                data-loading={isLoadingNotifActive}
              >
                {isLoadingNotifActive
                  ? renderThreeDotsLoader
                  : t("PROFILE").ACTIVATE_BROWSER_NOTIF}
              </button>
            </div>
          )}
        </div>

        {/* <button
          onClick={() => handleSendNotificatios()}
          className="settings_btn"
        >
          {t("PROFILE").SUBMIT}
        </button> */}
      </div>
    )
  );
};

export default Notifications;
